import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-service-followers',
  templateUrl: './service-followers.component.html',
  styleUrls: ['./service-followers.component.scss']
})
export class ServiceFollowersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
